import { render, staticRenderFns } from "./editSlot.vue?vue&type=template&id=7487d389"
import script from "./editSlot.vue?vue&type=script&lang=js"
export * from "./editSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports